module.exports = __webpack_public_path__ + "static/healthnx-mission-three-c5b8c8ed10ddc831bd431439617cbec8.jpg";